export default __webpack_public_path__ + "static/media/kustomize.f38b25fc.svg";